import BaseComponent from '../BaseComponent';

const NAME = 'MembersAreaNavbarNew';
const DATA_KEY = 'lta.membersAreaNavbarNew';

class MembersAreaNavbarNew extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	static get DATA_KEY() {
		return DATA_KEY;
	}

	dispose() {
		// Remove event handlers, reset constructor public settings etc.
		super.dispose();
	}

	init() {
		const navigationItems = this._element.querySelectorAll('li svg');

		navigationItems.forEach((nav) => {
			nav.addEventListener('click', () => {
				if (nav.closest('li').classList.contains('active')) {
					nav.closest('li').classList.remove('active');
					nav.parentElement.nextElementSibling.classList.add('u-hidden');
					nav.classList.remove('up_arrow');
					nav.classList.add('down_arrow');
				} else {
					nav.closest('li').classList.add('active');
					nav.parentElement.nextElementSibling.classList.remove('u-hidden');
					nav.classList.add('up_arrow');
					nav.classList.remove('down_arrow');
				}
			});
		});
	}
}

export default MembersAreaNavbarNew;
